/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Livid_Polite_Jackdaw_PropelInputs */

const en_livid_polite_jackdaw_propel = /** @type {(inputs: Livid_Polite_Jackdaw_PropelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long Token`)
};

/**
* | output |
* | --- |
* | "Long Token" |
*
* @param {Livid_Polite_Jackdaw_PropelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const livid_polite_jackdaw_propel = /** @type {((inputs?: Livid_Polite_Jackdaw_PropelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Livid_Polite_Jackdaw_PropelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_livid_polite_jackdaw_propel(inputs)
});